import { render } from "./index.vue?vue&type=template&id=c4713d30&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.scss?vue&type=style&index=0&id=c4713d30&lang=scss&scoped=true"

import exportComponent from "/Users/agnisvegners/Projects/anatomynext/hpc-new/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4713d30"]])

export default __exports__